import React, { useState } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'

import { connect } from 'react-redux';
import { updateLicense, updateClaimType, deleteDocTypeAll, updateClaimId, updateContactInfo  } from '../reducers/formActions'
import ThaivivatLogo from '../components/ThaivivatLogo.js'
import { markUp } from '../utils/mark-up';

function InformSelectCarComponent(props) {
  const navigate = useNavigate();
  let onSuccess = props.onSuccess
  let onFail = props.onFail
  let onUploadDocAction = props.onUploadDocAction
  let onBack = props.onBack
  let [ carLisenceList, setCarLisenceList ] = useState(props.data)

  const [ selectedCarLisence, setSelectedCarLisence ] = useState(null)
  const [ isErrorNotSelected, setIsErrorNotSelected ] = useState(null)


  async function submit(  ){
    if(selectedCarLisence === null){
      setIsErrorNotSelected(true)
    }
    else {

      let carInfo = carLisenceList[selectedCarLisence]
      const params = `notify_number=${props.notify_no}&car_license_alp=${carInfo.car_license_alp}&car_license_no=${carInfo.car_license_no}&car_license_province=${carInfo.car_license_province}&register_plate=${carInfo.register_plate}&sufferer_type=${carInfo.sufferer_type}`
      props.updateLicense(
        {
          front : carInfo.car_license_alp,
          no : carInfo.car_license_no,
          province : carInfo.car_license_province,
          is_red_plate : carInfo.register_plate,
          driver_name : carInfo.driver_name,
          sufferer_type : carInfo.sufferer_type
        }
      )

  
      props.deleteDocTypeAll()
      props.updateContactInfo(
        {
          contact_type : 0,
          name : '',
          contact_title_code : '',
          garage_code : '',
          garage_name : '',
          no_garage_in_system : false,
          is_attorney : false,
          is_company : false,
          tel : '',
          email : '',
          line_id : '',
          ref_no: ''
        }
      )
  
      onSuccess()
      setIsErrorNotSelected(false)
    }
  }


  async function callApiGetDraft(params ) {

  }


  function getDisplayLisence( data ){
    return `${data.car_license_alp}${data.car_license_no}`
  }
  function getDisplayLisenceProvice( data ){
    if (data.car_license_province && data.car_license_province != '') {
      return `${data.car_license_province}`
    }
    if (data.driver_name && data.driver_name != '') {
      const driverNameArr = data.driver_name.split(" ");
      return `${driverNameArr[0]} ${markUp(driverNameArr[1])}`
    }
    
    return ''
  }

  function onConfirm(referrenceNo){
    navigate("/summary", { state: { "referenceNo": referrenceNo }, replace: true })
  }

  
  return (
    <div className=' flex-wrap w-full '>

    <div className="flex-none md:hidden w-full bg-green-500 py-[11px] pl-4">
      <div className=''>
        <ThaivivatLogo></ThaivivatLogo>
      </div>
    </div>
    
    <div className='flex flex-wrap w-full justify-center '>
      <div className='flex-wrap w-full md:w-[428px] pt-10 px-4 md:px-11'>

        <div className='flex-wrap w-full'>
          <span className='flex w-full text-2xl md:text-[32px] font-medium leading-[44px]'>กรุณาเลือกทะเบียนรถ<br/>ของคุณ</span>
        </div>

        <div className='flex-wrap w-full mt-6 md:mt-10  max-h-[192px] overflow-y-auto'>
          {
            carLisenceList.map(function(item, index){
              //bg-green-200 bg-gray-300
              return (

                <div className={'flex w-ful  border-b border-grey-300 '+( (selectedCarLisence === index)? ' bg-green-200 ' : ''  )}>
                  <div className='flex-none py-5 px-4'>
                    <input data-testid='carLicense-radio' onChange={ () => { setSelectedCarLisence(index) } } type={"radio"} name="car-lisence" />
                  </div>
                  <div className='grow flex flex-wrap w-full py-3'>
                    <span className='w-full text-base font-medium leading-5'>{ getDisplayLisence(item) }</span>
                    <span className='w-full text-sm text-grey-600'>{ getDisplayLisenceProvice(item) }</span>
                  </div>
                </div>
              )
            })

          }
        </div>
        

        <div className='w-full mt-6'>
          <span data-testid='error-message-text' className={' w-full text-xs text-red-500 '+(( isErrorNotSelected === true )? ' flex ' : ' hidden ')}>กรุณาเลือกทะเบียนรถ</span>
        </div>

        


        <div className='w-full mt-6'>
          <button
              data-testid='next-button'
              onClick={submit}
              className={'w-full lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-md border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                ต่อไป
          </button>
        </div>




        <div className='w-full mt-6 md:mt-10'>
          <span className=' w-full text-base leading-5'>หากคุณไม่มีสามารถขอเลขรับแจ้งได้กับพนักงาน กรุณาติดต่อที่หมายเลข <span className='text-green-500'>1231 กด 4</span></span>
        </div>

        <div className='w-full mt-6 md:mt-10'>
          <span data-testid='back-button' onClick={ onBack } className=' cursor-pointer w-full text-base leading-5 text-green-500'>กลับไปก่อนหน้านี้</span>
        </div>

      </div>
    </div>
    </div>
  )
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    updateContactInfo : (payload) =>  dispatch(updateContactInfo(payload)),
    updateLicense : (payload) =>  dispatch(updateLicense(payload)),
    updateClaimType : (payload) =>  dispatch(updateClaimType(payload)),
    deleteDocTypeAll : () =>   dispatch(deleteDocTypeAll()),
    updateClaimId : (payload) =>   dispatch(updateClaimId(payload)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(InformSelectCarComponent);